import { useEffect } from "react";

// Lightweight per-route SEO: sets <title>, meta description, canonical, and
// Open Graph / Twitter tags. Works in a CRA SPA (Googlebot renders JS).
function setName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setProp(prop, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, path, image, type = "website", lang = "en" }) {
  useEffect(() => {
    const origin = window.location.origin;
    const url = path ? `${origin}${path}` : window.location.href.split("?")[0].split("#")[0];
    const prevTitle = document.title;
    if (title) document.title = title;

    setName("description", description);
    setProp("og:title", title);
    setProp("og:description", description);
    setProp("og:url", url);
    setProp("og:type", type);
    setProp("og:locale", lang === "fr" ? "fr_CA" : "en_CA");
    if (image) setProp("og:image", image);
    setName("twitter:title", title);
    setName("twitter:description", description);
    if (image) setName("twitter:image", image);
    document.documentElement.setAttribute("lang", lang);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    return () => { document.title = prevTitle; };
  }, [title, description, path, image, type, lang]);
}
